import { put, call } from "redux-saga/effects";
import ResponseParser from "../../../api/apiResponseParser";
import { GET_PATIENT_DETAILS, VALID_CLIENT_REQUEST, GET_CHILDREN_REQUEST, ADD_CHILDREN_REQUEST, ADD_USER_DETAILS_REQUEST, GET_CHECK_USER_DETAILS_SIGNED, GET_DOC_REQUEST, GET_ROOM_KEYS_REQUEST, GENERATE_CALLID_REQUEST, ADD_USER_TO_WAITING_REQUEST, UPDATE_ROOM_STATUS, NOTIFY_PROVIDER_REQUEST, CHECK_ROOM_STATUS_REQUEST, CALL_END_BY_PATIENT_REQUEST, DISCONNECT_REASON_REQUEST, PROVIDER_SETTINGS_REQUEST, INVALIDATE_REQUEST, CLEAR_DATA_REQUEST, UPLOAD_MEDICATIONS, ALLERGY_SEARCH, MEDICATION_SEARCH, ADD_FAMILY_MEMBER_REQUEST } from "../Actions/types";
import * as patientActions from '../Actions/PatientActions';
import * as registerActions from '../Actions/RegisterActions';
import { getPatientDetails, getOpentokRoomKeys, generateCallIdByPatientId, addUserToWaitingRoom, updateRoomStatus, invalidateAPI, providerSettingsAPI, disconnectReasonAPI, callEndByPatientAPI, checkRoomStatus, notifyProvider, getDocFromAlias, uploadMedication, searchMedication, searchAllergy } from "../../../api/apiMethods/patientMethod";
import validateClient from "../../../api/apiMethods/validClientUrl";
import { getChildrenList, addChildren, addUserDetails, checkUserDetailsSigned, addFamilyMember } from "../../../api/apiMethods/getChildren";

export default function* patientSaga(actions) {
    if (actions.type === GET_PATIENT_DETAILS) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            getPatientDetails,
            actions.patientId,
            actions.token,
        );
        let data = yield ResponseParser(response);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.patientDetailResponse(data));
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === VALID_CLIENT_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(validateClient, actions.payload, actions.token);
        let data = yield ResponseParser(response);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.onValidClientResponse(data.result));
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.validationFailed());
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === GET_CHILDREN_REQUEST) {
        // const params = new FormData();
        // params.append('patientId', actions.params);
        yield put(patientActions.enableLoader());
        const response = yield call(getChildrenList, actions.params, actions.token);
        //console.log('gsef', response);
        let data = yield ResponseParser(response);
        //console.log('gsef', response, data);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.onGetChildrenResponse(data.result || []));
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.onGetChildrenFailed({}));
            yield put(registerActions.onErrorOccured(data));
        }
    } else if (actions.type === ADD_CHILDREN_REQUEST) {
        console.log("APi called");
        yield put(patientActions.enableLoader());
        const response = yield call(addChildren, actions.payload, actions.token);
        let data = yield ResponseParser(response);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.onAddChildrenResponse(data || []));
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === ADD_FAMILY_MEMBER_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            addFamilyMember,
            actions.payload,
            actions.token,
        );
        //console.log('addFamilyMember', response);
        let data = yield ResponseParser(response);
        //console.log('addFamilyMember', response, data);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.onAddFamilyMemberResponse(true || []));
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
        }
    } else if (actions.type === ADD_USER_DETAILS_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(addUserDetails, actions.payload, actions.token);
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.addUserConsentsDetailsResponse(data || []));
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.addUserConsentsDetailsFailed([]));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === GET_CHECK_USER_DETAILS_SIGNED) {
        yield put(patientActions.enableLoader());
        const response = yield call(checkUserDetailsSigned, actions.payload, actions.token);
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.checkUserConsentsDetailsResponse(data || []));
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === GET_DOC_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            getDocFromAlias,
            actions.payload,
            actions.token,
        );
        let data = yield ResponseParser(response);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.onGetDocFromAliasResponse(data.result));
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.getDocFailed());
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === GET_ROOM_KEYS_REQUEST) {
        yield put(patientActions.enableLoader());

        const response = yield call(
            getOpentokRoomKeys,
            actions.payload,
            actions.token,
        );

        let data = yield ResponseParser(response);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.onGetRoomKeysResponse(data.result));
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.getRoomKeysFailed());
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === GENERATE_CALLID_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            generateCallIdByPatientId,
            actions.payload,
            actions.token,
        );
        let data = yield ResponseParser(response);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.onGenerateCallIDResponse(data.result));
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.generateCallIDFailed());
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === ADD_USER_TO_WAITING_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            addUserToWaitingRoom,
            actions.payload,
            actions.token,
        );
        //console.log('addUserToWaitingRoomaddUserToWaitingRoom', actions.payload);
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            yield put(patientActions.onAddUserToWaitingResponse(data));
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.addUserToWaitingFailed());
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === UPDATE_ROOM_STATUS) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            updateRoomStatus,
            actions.payload,
            actions.token,
        );
        let data = yield ResponseParser(response);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.onUpdateRoomStatusResponse(data));
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === NOTIFY_PROVIDER_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(notifyProvider, actions.payload, actions.token);
        let data = yield ResponseParser(response);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.onNotifyProviderResponse(data));
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.notifyProviderFailed());
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === CHECK_ROOM_STATUS_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            checkRoomStatus,
            actions.payload,
            actions.token,
        );
        let data = yield ResponseParser(response);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.onCheckRoomStatusResponse(data));
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.onCheckRoomStatusResponse(data));
            // yield put(patientActions.checkRoomStatusFailed());
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            // apiFailure(data);
        }
    } else if (actions.type === CALL_END_BY_PATIENT_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            callEndByPatientAPI,
            actions.payload,
            actions.token,
        );
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.disableLoader({}));
        }
    } else if (actions.type === DISCONNECT_REASON_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            disconnectReasonAPI,
            actions.payload,
            actions.token,
        );
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.disableLoader({}));
        }
    } else if (actions.type === PROVIDER_SETTINGS_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            providerSettingsAPI,
            actions.payload,
            actions.token,
        );
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.disableLoader({}));
        }
    } else if (actions.type === INVALIDATE_REQUEST) {
        yield put(patientActions.enableLoader());
        const response = yield call(invalidateAPI, actions.payload, actions.token);
        if (response.status == 200 || response.status == 201) {
            yield put(patientActions.disableLoader({}));
        } else {
            yield put(patientActions.disableLoader({}));
        }
    } else if (actions.type === CLEAR_DATA_REQUEST) {
        yield put(patientActions.onClearDataSuccess());
    } else if (actions.type === UPLOAD_MEDICATIONS) {
        yield put(patientActions.enableLoader());
        const response = yield call(
            uploadMedication,
            actions.payload,
            actions.token,
        );
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            yield put(patientActions.disableLoader({}));
            // if (actions.gender.toLowerCase() === 'female') { }
            // //NavigationService.navigate('womenQuestions');
            // else 
            if (actions.userType === 10001) {
                yield put(patientActions.uploadMedicationsSuccess(true));
                //NavigationService.navigate('callPreview', { roomName: actions.room });
            } else {
                yield put(patientActions.uploadMedicationsSuccess(true));
            }
            //NavigationService.navigate('callPreview', { roomName: actions.room });
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            console.log("Upload Medical failed");
        }
    } else if (actions.type === MEDICATION_SEARCH) {
        yield put(patientActions.enableLoader());
        const params = new FormData();
        params.append('searchString', actions.query);
        const response = yield call(searchMedication, params, actions.token);
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.onSearchMedication(data.result));
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    } else if (actions.type === ALLERGY_SEARCH) {
        yield put(patientActions.enableLoader());
        const params = new FormData();
        params.append('searchTerm', actions.query);
        const response = yield call(searchAllergy, params, actions.token);
        let data = yield ResponseParser(response);
        if (response.status == 200) {
            yield put(patientActions.disableLoader({}));
            yield put(patientActions.onSearchAllergy(data.result));
        } else {
            yield put(patientActions.disableLoader({}));
            yield put(registerActions.onErrorOccured(data));
            //apiFailure(data);
        }
    }
}